var _rect, _rect2, _rect3, _rect4, _path, _line;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSinkCabinetOpen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 542,
    height: 481,
    viewBox: "0 0 542 481",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 153,
    width: 397,
    height: 195,
    fill: "#A9633C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 83,
    y: 168,
    width: 377,
    height: 47,
    fill: "#E1976D"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 168,
    width: 377,
    height: 169,
    fill: "#452F23"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 128,
    width: 426,
    height: 25,
    fill: "#C87749"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73 348H470L484 380H64L73 348Z",
    fill: "#C87749"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 266,
    y1: 168,
    x2: 266,
    y2: 337,
    stroke: "#984B20",
    strokeWidth: 8
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSinkCabinetOpen);
export default __webpack_public_path__ + "static/media/sink_cabinet_open.f35e6b76f8e0937be3e754dc025168d4.svg";
export { ForwardRef as ReactComponent };